module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "x1chap-num",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#chapter-2"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-first",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("T")]), _vm._v("he night called to her.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She lay in bed, trying not to fidget, for Cassandra slept lightly and Jane did not want to disturb her. But the night, its velvet shadows and the thin gleam of moonlight, beckoned to her. She remembered the embrace of darkness, of slipping through the shadows, strong and dangerous and graceful.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane punched her pillow and tried to compose her mind to sleep. In her mind she recited verses from the Bible, poems, the dates of the kings and queens of England, old familiar friends that she had long relied on to lull her into drowsiness. She counted the chimes of the clock in the house and the church clock. But the restlessness prevailed. Memories of power and strength and swiftness came and went.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Memories of being Damned.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("More than a decade ago she had accepted such occasional phantasms as part of her being—for she had no word for what she experienced; for certain, she was sure no one else could understand these sensations. She had tried once, timidly, to ask Cassandra for advice, and her sister, blushing furiously, had thought Jane admitted to some solitary sensual temptation. Prayer, Cassandra advised, and keeping busy, and (blushing even deeper) Jane should keep her hands above the bedclothes.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Oh, if only Cassandra knew.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("But Cassandra didn’t want to know or even remember. And apparently neither did the Prince of Wales—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oh, George, you are such a fat, foolish thing. And to think you were once my friend. If only I could speak to you and make you see sense.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We have tried.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane sat bolt upright in bed. The reply to her thoughts had come through as clean and sharp as though someone—only she wasn’t sure who—had spoken into her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Who are you? Where are you?")]), _vm._v(" she asked, fearful, but no reply came.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She slipped from her bed and onto her knees, shivering a little in the chilly air of the spring night (of course the fire was not lit; what a dreadful extravagance that would be!). She clasped her hands and prayed fervently. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Father, if Thou be willing, remove this cup from me: nevertheless not my will, but Thine, be done.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She rested her forehead on her joined hands, and her thoughts, if not her actual prayer, shifted to her father. Dear James, he’d looked so like him today, with his strong wavy hair and handsome profile, trying hard to be stern with his troublesome daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Her knees ached at the contact with the cold wooden floor, but before she slid back into bed, she whispered one final short, urgent prayer. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dear Lord, do whatever You will, but please let me write. And let Cassandra love me still.")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-after-txb1",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("T")]), _vm._v("he next morning the Austen ladies sat in their drawing room, hands busy at their work. Jane looked at her sister and wondered if the two of them were in some secret, unspoken competition as to who should produce the most unbecoming cap. Even Cassandra, pretty Cassandra—if a woman of her age could be described as pretty—looked rather like a handsome sheep in hers, her chestnut hair covered. Jane might be the only one who knew that a slender streak of gray adorned her sister’s rich hair.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane dipped her needle into the piece of fabric she had chosen from among the pile of scraps on the table, proud of her small, neat stitches. This gown, she remembered this gown, worn at Godmersham a few years ago, when she had sported a flattering, dashing cap and allowed herself the pleasure of a lot of wine and a little flirtation. And now it was to be part of a handsome quilt, its memories captured and tamed.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I do not think anyone will come to call,” Mrs. Austen pronounced, laying her work aside. “A little nuncheon, I believe, and then—”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("But someone hammered at the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Heavens, it sounds as though the Watch is come to arrest us,” Cassandra said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Doubtless to arrest my aunts for their dreadful caps,” Anna said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane listened as their maidservant opened the door and announced that, yes, the ladies were home. She didn’t recognize the voices—or did she? But there was something she did recognize, even without seeing or even hearing the visitors, a knowledge of who they truly were. Certainly she had encountered members of the Damned a few times since 1797, strangers she identified as such by their beauty and pallor and grace. Always she had looked away, fearing that those long, painful days of the Cure, the poison of the Bath waters weakening her and returning her to a mortal state, might be undone. But to have the Damned come to call—and so early in the day!—surely they could not be her brother Edward’s tenants?")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Mrs. Kettering, ma’am, from the Great House.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Two ladies entered the room, the second, from her plainer dress and the large basket she carried, an upper servant. But the first . . . she swooped to take Mrs. Austen’s hand, all charm and seduction, making the simplicity of the parlor appear drab and provincial, and Jane was powerless to stop her. She introduced herself as Dorcas Kettering.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Mrs. Austen! I have taken the liberty of coming to call without a letter of introduction, but dear Mr. and Mrs. Knight assured us it would be perfectly correct. Why, you must be Miss Austen and Miss Jane, and who is this charming young lady? Will you not introduce me?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Power sizzled up Jane’s arm as she took the woman’s hand. Their eyes met, Mrs. Kettering’s mischievous and knowing. With as much composure as she could muster, Jane introduced Anna.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane stared in horror as Mrs. Kettering took both of Anna’s hands in hers and smiled upon her. “Why, what a pretty child you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Anna is my niece,” Jane said in a panic. “She visits us in Chawton. Her father is a clergyman. Quite nearby.” As though that would make any difference.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Mrs. Kettering was dowdily dressed, although it did little to hide her beauty, with a bonnet in a shape that had been fashionable a few years ago and an elaborate tucked and embroidered cotton gown. Despite the dry weather she wore a pair of pattens over incongruous jeweled dancing slippers. The woman who accompanied her, plainly dressed and with a chatelaine hanging from her bosom, sat quietly in a corner, the basket on her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“And how do you get on in the Great House?” Mrs. Austen asked. “It is a shockingly old-fashioned place, but my son Edward plans many improvements.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“We are very comfortable, ma’am,” Mrs. Kettering replied. “The other ladies and gentlemen of our party all agree it is a most handsome and pleasant house. But you must see for yourself, for I have come here with the express purpose of inviting you to dine.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("To "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dine")]), _vm._v("! Jane interrupted her hastily. “I regret we do not—”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Now, Jane,” her mother interrupted, “here is Martha with some more hot water. You’ll take tea, Mrs. Kettering. This is Miss Lloyd, our particular friend who looks after us all. And how do you like our little village, ma’am?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“It is altogether charming!” she cried. “And this house is so delightful, so snug and . . . rural. Do you know, Mrs. Austen, we have seen some cows this morning!”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“How extraordinary,” Jane said. She handed Mrs. Kettering a cup of tea, wishing she could dash it into her face.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“So, you will dine with us tomorrow,” Mrs. Kettering said. “My brother-in-law Fitzpatrick insists you must, and he begs to be remembered to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Fitzpatrick?” Mrs. Austen’s brow creased. “I don’t believe we know . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“He met you in Bath some dozen years ago, ma’am, and was kind enough to help you find some lodgings.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh! I remember now—although at first I did not recognize the name. I could have sworn his name was Fitzwilliam. He was most kind to us during that unsettled time.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“It is the same gentleman, ma’am, and he begs to be remembered to you all. Pressing business prevented him from accompanying me this morning, or so he says, but you know how gentlemen are about morning calls. They are so easily bored with our feminine chatter.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane almost choked on her tea in anxiety. William, who had introduced himself to her parents and sister as Fitzwilliam, was now here in Chawton! No wonder she had been so unsettled, and surely it was William who had spoken in her mind last night.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Cassandra patted Jane on the back as she spluttered and dabbed at her lips with her handkerchief. “We no longer go out in society—” Jane began, but she was interrupted by her mother and Cassandra and Martha, who accepted the invitation with great excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, it will be a very quiet affair,” Mrs. Kettering said. “But three or four families, although we can promise Miss Anna dancing and some very handsome partners after dinner. You do like to dance, do you not, Miss Anna? Ah, I thought so.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You are most kind, Mrs. Kettering,” Mrs. Austen cried.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“We are supposed to be keeping Anna out of trouble. She is here for punishment,” Jane hissed to Cassandra. “She—”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Cassandra raised her eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Nonsense, look how excited the child is,” Mrs. Austen said. “Why, it will do her good to have a little pleasure. And as Mrs. Kettering says, it will be a very quiet affair.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“So, it is settled,” Mrs. Kettering said, beaming and showing a lot of teeth. “We shall send our carriage for you at eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Eight, ma’am?” Jane asked.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, of course. Yes. This is the country. At four, then. Now, maybe you can advise me, Mrs. Austen. My housekeeper, Mrs. Chapple, and I intend to visit the sick and the poor of the village. Whom would you recommend we visit?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“No!” The word burst out before Jane could prevent herself, accompanied by a jolt of pain in her canines. Her teacup rolled from her lap onto the floor, scattering tea leaves onto the carpet.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Why, Jane, whatever is the matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I beg your pardon, ma’am. Toothache,” Jane mumbled, on her knees to retrieve the teacup. She swabbed at the carpet with her handkerchief.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, do not do that, Jane,” Martha said. “It will stain the linen. Let me fetch you a clean cloth and some oil of cloves for your poor tooth. Excuse me, Mrs. Kettering.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Let me think,” Mrs. Austen said as Martha left the room. “There is always Miss Benn, of course, but she is a gentlewoman in distress.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I beg of you, Mrs. Kettering, do not visit Miss Benn. She will not accept charity,” Jane said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“And poor Betty Cooper is quite ill,” Cassandra said. “She swooned while walking out—we do not know why she ventured from home—but now lies pale and exhausted and feeble. Martha and I saw her yesterday. I hope she has improved.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“She sounds just the thing!” Mrs. Kettering cried. “So, ladies, Mrs. Austen and Miss Austen and Miss Jane and Miss Anna, we shall be on our way. Where can we find this unfortunate Betty?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I shall show you the way,” Jane said. “Allow me to fetch my bonnet, ma’am.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("She dashed into the vestibule where a row of pegs held the family’s bonnets and cloaks and joined Mrs. Kettering and the housekeeper, escorting them from the house with a sigh of relief.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I know what you are,” Jane said when they were a few steps away. “Pray never come to my house again.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Mrs. Kettering smiled. “And I know what you are, dear Jane. No, do not deny it. The Cure is rarely successful—well, sometimes it kills, so I suppose it is successful, for the afflicted then goes to heaven, having repented—but in most cases the signs of your true nature come and go for the rest of your mortal life. But let us not stand on formality. You must call me Dorcas.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I would prefer not to. And I will certainly persuade my family that you are not fit company, even if you live in Edward’s house.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, foolish Jane.” Dorcas took her hands and once again Jane felt the surge of power and awareness, of aching familiarity. “You wish to see William, your Creator. It is natural.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Stop it!” Jane wrenched her hands away. “Neither shall I allow you to visit poor Betty or anyone else in the village. Doubtless you wish to dine upon her.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Dorcas’s canines extended a little: a warning. “You mistake me, my dear. We are country people now. We do our duty to those less fortunate than ourselves. Of course,” she added thoughtfully, “that is almost everyone else, but we must do our best.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("They stepped back as a coach rattled down the street, Dorcas’s housekeeper placing her basket on the ground with a sigh of relief.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“What on earth do you have in your basket?” Jane asked. “It looks very heavy.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, some nourishing foods,” Dorcas said. “Some lemon tarts and a turkey.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“For the sick and the poor?” Jane shook her head. “You are much mistaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Indeed?” Dorcas no longer looked offended; now her expression was one of perplexity.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“How would a poor family cook a turkey? Their hearth is not big enough. And lemon tarts are certainly not suitable for an invalid. You should provide gruel or a jelly. Martha can give your housekeeper a recipe—” Jane stopped herself. She would certainly prevent any contact between the Austen household and the inhabitants of the Great House.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Dorcas beamed. “Oh, how very kind of you. But tell me, do I look the part?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Not at all.” Jane felt a certain pleasure as Dorcas’s face fell. “Your bonnet is too gaudy, your gown unbecoming and ostentatious, and you need to buy a pair of half boots like mine. The dancing slippers and pattens are ridiculous.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“We have so much to learn, dear Jane.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“But not from me or my household, I regret. I’ll bid you good day, Mrs. Kettering. Pray do not call upon us again.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, here comes my brother!” Dorcas waved as a rider approached.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("As man and horse came nearer, Jane could see that the mount was in distress, flecked with foam and showing the whites of its eyes; no wonder, with one of the Damned astride it. The rider struggled to control the horse, which whinnied and shied as it caught sight of Dorcas (Jane refused to consider that she, too, might be a cause of fear), and the gentleman fell from the saddle, landing with a loud thump on the dusty road.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The horse kicked up its heels and galloped back along the road, stirrups swinging.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Damnation,” the gentleman said, and rose to his feet, brushing mud from his coat and reaching for his hat. “Miss Jane Austen, I presume.” He bowed. “Your servant, ma’am. Tom Fuller.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“You are riding! Why?” Jane burst out. Everyone knew of animals’ dislike of the Damned.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I am a country squire,” Mr. Fuller replied. “Country squires ride. So must I, although, devil take it, this hat is ruined. The wretched beast trod upon it.” He smacked at a hoofprint denting the smooth surface of his beaver hat. “I shall talk with William about increasing the dosage. We give them a little of our blood with their feed, Jane, to accustom them to our presence, but apparently not enough. William is most anxious to see you, by the by.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I regret that is unlikely, Mr. Fuller. I have no intention of renewing our acquaintance. In fact, I suggest you all return to town where you and your favored activities so obviously belong.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Favored activities?” Mr. Fuller revealed himself "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("en sanglant")]), _vm._v(". “Do not deceive yourself, Jane. You are one of us. And we have every intention of staying here.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Jane has been so very helpful and neighborly already!” Dorcas cried. “Why, country living will suit us so extremely well, particularly with the Austens as our friends. They are to dine with us tomorrow, Tom.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Excellent. Until tomorrow, Jane. I must make sure my errant horse has returned safely to the stables.” He bowed and strolled away, the battered hat replaced on his head.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I shall accompany you,” Dorcas called after him. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Au revoir,")]), _vm._v(" Jane.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm-after-txb1",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "initial-caps"
  }, [_vm._v("J")]), _vm._v("ane went back into the house where already Anna had brought her best gown into the drawing room and was deep in conversation with Cassandra about how it might be altered, for both of them agreed that Mrs. Kettering’s day dress was so very smart the Austens feared they would be put to shame.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane glanced out the window. Mrs. Austen had retired to the garden, where clad in her usual green smock, straw hat, and serviceable thick gloves, she was engaged in planting the cuttings James had brought over the day before.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Frowning, Jane retired to the dining room and drew a chair up to the table by the window. She opened her writing slope and removed a creased and stained bundle of papers, along with the clean copy she was making. Yes, it made sense, but for how long? When she had been Damned before, her words had appeared like a mystifying code, a tale told by an idiot, merely words on the page with no sense or coherence.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Or, Jane thought, maybe she had just written badly. She read through the first page in her hand. Some of it was smeared and illegible, but the rest made sense, even if the writing was somewhat clumsy. She smiled and reached for her quill, drawing her fingers down the feather.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A great bird, wings outspread, hissing through an orange beak; green grass, the glimmer of steel gray water beyond, the scent of grass and mud and rank river")]), _vm._v("—she dropped the quill. Queasily she glanced around the room, knowing that any object she touched might communicate through her skin into her mind, and that she must once again learn to control and push aside the immediate, disturbing sensations.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("With great care she leaned to pick up the quill and laid it on the small table next to the manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The door creaked open and Jane turned, annoyed at the interruption.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Oh, Aunt Jane, I am sorry to disturb you, for Aunt Cassandra said I should do so only on a very urgent matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“What is it, my dear?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Aunt Cassandra said I must ask you if you knew where her pink ribbon has gone. She is sure we have it somewhere, but if we cannot find it we must go into Alton to buy more.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Pink ribbon?” Jane echoed.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Anna moved closer, leaning on her chair, her arm brushing against Jane’s. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aunt Jane is so pretty and lively still, I wonder why she did not marry. Oh and maybe tomorrow I shall meet some handsome young gentlemen and I hope my hair curls and . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Jane shifted to break the contact and avoid the intrusion into Anna’s thoughts. “My dear, I am afraid I have no idea. Is it absolutely necessary?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“It is a matter of life and death,” Anna said with a self-satirizing air that Jane appreciated. She leaned over her aunt’s shoulder. “Is this your book?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“One of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“It looks as though something spilled all over it. What a shame. But you can see some of the words. Do you make a fair copy? Did you spill tea onto it?”")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Something of that sort,” Jane said.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Even now, aided by the extraordinarily sensitive sense of smell the Damned possessed, she could pick up the scent of those faded brown stains. Repulsion and longing stirred within her.")]), _vm._v(" "), _c('p', {
    staticClass: "x1bm",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Thirteen years ago the pages had been soaked in blood.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2421910a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_2.vue
// module id = 72
// module chunks = 0